module.exports = __webpack_public_path__ + "img/ktroom2.4f511830.png";